import React from "react";
import { Info } from "react-feather";
import i18n from "i18next";

function ReusableBowlsPaymentBanner() {
    return (
        <div className="reusable-bowls-payment">
            <Info size={20} />
            <div className="reusable-bowls-payment__text">
                {i18n.t("cart.reusableBowls.paymentBanner")}
            </div>
        </div>
    );
}

export default ReusableBowlsPaymentBanner;
